'use strict';

var React = require('react');

var SvgCollectionReferenceIcon = function SvgCollectionReferenceIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13 2.5c.414 0 .75.336.75.75s-.336.75-.75.75h-3.029c-.468 0-.917.188-1.245.521l-4.692 4.756c-.291.295-.766.298-1.06.007-.296-.291-.299-.766-.008-1.06l4.692-4.756c.61-.62 1.444-.968 2.313-.968h3.029Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.419 5c-.995 0-1.949.395-2.652 1.098l-3.883 3.883c-1.074 1.074-1.074 2.816 0 3.89l3.058 3.057c.763.764 2 .764 2.764 0 .293-.292.293-.767 0-1.06-.293-.293-.768-.293-1.06 0-.178.177-.466.177-.643 0l-3.058-3.058c-.489-.488-.489-1.28 0-1.768l3.883-3.883c.421-.422.994-.659 1.59-.659h2.082c.69 0 1.25.56 1.25 1.25v3.324c0 .414.336.75.75.75s.75-.336.75-.75v-3.324c0-1.519-1.231-2.75-2.75-2.75h-2.081Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 8.5c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.03 16.47c.293.293.293.767 0 1.06-.293.293-.767.293-1.06 0l-2.22-2.22v1.19c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-3c0-.2.08-.39.22-.53.14-.141.331-.22.53-.22h3c.414 0 .75.336.75.75s-.336.75-.75.75h-1.19l2.22 2.22Z"
  }));
};
SvgCollectionReferenceIcon.displayName = "CollectionReferenceIcon";

exports.SvgCollectionReferenceIcon = SvgCollectionReferenceIcon;
